module.exports = __webpack_public_path__ + "img/digital-art-draw.d55eaeba.svg";